import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'titon',
} as IModuleProps;
